/* eslint-disable max-lines */
import { css } from 'linaria';
import { styled } from 'linaria/react';

export const CategoryImageGrid = styled.div`
  display: grid;
  column-gap: 16px;

  @media (--only-desktop) {
    column-gap: 14px;
  }

  @media (--only-tablet) {
    column-gap: 12px;
  }
`;

export const CategoryImageGridMap: Record<number, string> = {
  2: css`
    grid-template-columns: 1fr 1fr;
    column-gap: 17px;

    @media (--only-desktop) {
      column-gap: 14px;
    }

    @media (--only-tablet) {
      column-gap: 12px;
    }

    @media (--only-mobile) {
      row-gap: 20px;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;
    }
  `,
  3: css`
    grid-template-columns: repeat(3, 1fr);

    @media (--only-mobile) {
      row-gap: 12px;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr 1fr;
    }
  `,
  4: css`
    grid-template-columns: repeat(4, 1fr);
    column-gap: 17px;

    @media (--only-desktop) {
      column-gap: 14px;
    }

    @media (--only-tablet) {
      column-gap: 12px;
    }

    @media (--only-mobile) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
      gap: 20px 16px;
    }
  `,
  5: css`
    grid-template-columns: 380px 180px 180px 380px;
    column-gap: 20px;
    row-gap: 24px;

    @media (--only-desktop) {
      grid-template-columns: 304px 145px 145px 304px;
      column-gap: 14px;
    }

    @media (--only-tablet) {
      grid-template-columns: 212px 100px 100px 212px;
      column-gap: 12px;
      row-gap: 20px;
    }

    @media (--only-mobile) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 20px;

      & :nth-child(5) {
        grid-column: span 2;
      }
    }

    @media (--from-tablet) {
      & :nth-child(1),
      & :nth-child(2),
      & :nth-child(4) {
        grid-column: span 2;
      }
    }
  `,
  6: css`
    grid-template-columns: repeat(3, 380px);
    column-gap: 20px;
    row-gap: 24px;

    @media (--only-desktop) {
      grid-template-columns: repeat(3, 304px);
      column-gap: 14px;
    }

    @media (--only-tablet) {
      grid-template-columns: repeat(3, 212px);
      column-gap: 12px;
    }

    @media (--only-mobile) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 20px;
    }
  `,
  7: css`
    grid-template-columns: 282px 81px 182px 181px 81px 282px;
    grid-template-rows: 1fr 1fr;
    column-gap: 17px;
    row-gap: 24px;

    @media (--only-desktop) {
      grid-template-columns: 225px 65px 145px 145px 65px 225px;
      column-gap: 14px;
    }

    @media (--only-tablet) {
      grid-template-columns: 156px 44px 100px 100px 44px 156px;
      column-gap: 12px;
      row-gap: 20px;
    }

    @media (--only-mobile) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 20px;

      & :nth-child(1) {
        grid-column: span 2;
      }
    }

    @media (--from-tablet) {
      & :nth-child(1),
      & :nth-child(2),
      & :nth-child(3),
      & :nth-child(5),
      & :nth-child(6) {
        grid-column: span 2;
      }
    }
  `,
  8: css`
    grid-template-columns: repeat(4, 1fr);
    column-gap: 17px;
    row-gap: 24px;

    @media (--only-desktop) {
      column-gap: 14px;
    }

    @media (--only-tablet) {
      column-gap: 12px;
      row-gap: 20px;
    }

    @media (--only-mobile) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 20px;
    }
  `,
};

export const invertCategoryCardGridMap: Record<number, string> = {
  3: css`
    @media (--only-mobile) {
      gap: 16px;

      :first-child {
        grid-column: unset;

        p {
          white-space: unset;
        }
      }

      :last-child {
        grid-column: span 2;

        p {
          white-space: initial;
        }
      }
    }
  `,
  5: css`
    @media (--from-tablet) {
      & :nth-child(2),
      & :nth-child(4),
      & :nth-child(5) {
        grid-column: span 2;
      }

      & :nth-child(1) {
        grid-column: 1;
      }
    }

    @media (--only-mobile) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 16px;
      row-gap: 20px;

      & :nth-child(1) {
        grid-column: span 2;
      }
      
      & :nth-child(5) {
        grid-column: unset;
      }
    }
  `,
};

export const categoryItemImg = css`
  display: block;
  width: 100%;
  height: 180px;
  margin-bottom: 16px;
  border-radius: var(--rounding-m);
  object-fit: cover;

  @media (--only-desktop) {
    height: 143px;
    margin-bottom: 12px;
  }

  @media (--only-tablet) {
    height: auto;
    margin-bottom: 8px;
  }

  @media (--only-mobile) {
    height: auto;
    margin-bottom: 8px;
  }
`;

export const categoryImageTitle = css`
  && {
    line-height: 28px;
    white-space: pre-wrap;

    @media (--only-desktop) {
      font-size: 16px;
      line-height: 22px;
    }

    @media (--to-desktop) {
      font-size: 14px;
      line-height: 18px;
    }
  }
`;

export const CategoryActionCard = styled.div`
  cursor: pointer;
`;
